import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { headerEmpresa } from '../../helpers/headerEmpresa';
import { getEmpresa } from '../../../services/empresaService';

async function PedidosPdf(pedidos) {

    function converterParaHoraLocal(utcString) {
        const data = new Date(utcString);
        return data.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: 'America/Sao_Paulo'
        });
    }

    function converterDataIsoParaBr(dataIso) {
        const data = new Date(dataIso);
        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();
        return `${dia}/${mes}/${ano}`;
    }

    pedidos = Array.isArray(pedidos) ? pedidos : [];

    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    // ✅ Busca dados da empresa
    const empresa = await getEmpresa();

    const reportTitle = {
        text: 'Relatório de Vendas',
        fontSize: 15,
        alignment: 'center',
        bold: true,
        margin: [0, 10, 0, 20]
    };

    const soma = pedidos.reduce((total, v) => total + (v.TOTAL ?? 0), 0);
    const totalDescontos = pedidos.reduce((total, v) => total + (v.DESCONTO ?? 0), 0);
    const quantidadeItens = pedidos.length;

    const dados = pedidos.map((pedido) => ([
        { text: pedido.COD_VENDA ?? '', fontSize: 7 },
        { text: converterDataIsoParaBr(pedido.DATA) ?? '', fontSize: 7 },
        { text: converterParaHoraLocal(pedido.HORA) ?? '', fontSize: 7 },
        { text: pedido.CAIXA ?? '', fontSize: 7, alignment: 'center' },
        { text: pedido.NUMCCF ?? '', fontSize: 7, alignment: 'center' },
        { text: pedido.NOME ?? '', fontSize: 7 },
        { text: pedido.FINALIZADORA ?? '', fontSize: 7 },
        {
            text: 'R$ ' + (Number(pedido.VALOR ?? 0) + Number(pedido.DESCONTO ?? 0)).toFixed(2),
            fontSize: 7,
            alignment: 'right'
        },
        {
            text: 'R$ ' + Number(pedido.DESCONTO ?? 0).toFixed(2),
            fontSize: 7,
            alignment: 'right'
        },
        {
            text: 'R$ ' + Number((pedido.TOTAL ?? 0) - (pedido.DESCONTO ?? 0)).toFixed(2),
            fontSize: 7,
            alignment: 'right'
        }
    ]));

    const details = {
        table: {
            headerRows: 1,
            widths: [40, 50, 30, 30, 40, 40, 60, 50, 50, 40],
            body: [
                [
                    { text: 'Código', style: 'tableHeader' },
                    { text: 'Data', style: 'tableHeader' },
                    { text: 'Hora', style: 'tableHeader' },
                    { text: 'Caixa', style: 'tableHeader' },
                    { text: 'Nº Nota', style: 'tableHeader' },
                    { text: 'Op. Caixa', style: 'tableHeader' },
                    { text: 'Finalizadora', style: 'tableHeader' },
                    { text: 'Sub-Total', style: 'tableHeader', alignment: 'right' },
                    { text: 'Desconto', style: 'tableHeader', alignment: 'right' },
                    { text: 'Total', style: 'tableHeader', alignment: 'right' }
                ],
                ...dados
            ]
        },
        layout: 'lightHorizontalLines'
    };

    const docDefinitions = {
        pageSize: 'A4',

        // 🔹 margem maior por causa do header global
        pageMargins: [15, 60, 15, 40],

        // ✅ Cabeçalho padrão (empresa + data + hora)
        header: headerEmpresa(empresa),

        content: [
            reportTitle,
            details,
            {
                text: `Quantidade de Vendas: ${quantidadeItens}`,
                alignment: 'right',
                bold: true,
                fontSize: 10,
                margin: [0, 10, 20, 0],
                color: 'blue'
            },
            {
                text: `Total Bruto: R$ ${soma.toFixed(2)}`,
                alignment: 'right',
                bold: true,
                fontSize: 10,
                margin: [0, 0, 20, 0]
            },
            {
                text: `Total de Descontos: R$ ${totalDescontos.toFixed(2)}`,
                alignment: 'right',
                bold: true,
                fontSize: 10,
                margin: [0, 0, 20, 0],
                color: 'red'
            },
            {
                text: `Total Líquido: R$ ${(soma - totalDescontos).toFixed(2)}`,
                alignment: 'right',
                bold: true,
                fontSize: 10,
                margin: [0, 0, 20, 0],
                color: 'green'
            }
        ],

        footer: (currentPage, pageCount) => ({
            text: `${currentPage} / ${pageCount}`,
            alignment: 'right',
            fontSize: 9,
            margin: [0, 10, 20, 0]
        }),

        styles: {
            tableHeader: {
                bold: true,
                fontSize: 10
            }
        }
    };

    pdfMake.createPdf(docDefinitions).open();
}

export default PedidosPdf;